<template>
    <v-layout align-start justify-space-between class="mb-3">
        <v-flex>
            <v-layout column class="subheading mx-4 my-3">
                <div class="text-h6">Customer Information</div>
                <v-layout class="mt-3 mb-2">
                    <v-flex xs4>Name:</v-flex>
                    <v-flex>{{ info.first_name }} {{ info.last_name }}</v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Email:</v-flex>
                    <v-flex>{{ info.email }}</v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Phone:</v-flex>
                    <v-flex>{{ info.phone_number }}</v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Move In Date:</v-flex>
                    <v-flex>{{ formatDate(options.moveInDate) }}</v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Follow Up Date:</v-flex>
                    <v-flex>{{ formatDate(options.followupDate) }}</v-flex>
                </v-layout>
            </v-layout>
        </v-flex>
        <v-flex v-if="unitFeatures">
            <v-layout column class="subheading mx-4 my-3">
                <div class="text-h6">Lead Details</div>
                <v-layout class="mt-3 mb-2">
                    <v-flex xs4>Size:</v-flex>
                    <v-flex>'{{ formatNumber(unitFeatures.width) }} x '{{ formatNumber(unitFeatures.length) }}</v-flex>
                </v-layout>
                <v-layout class="mb-2" justify-space-between>
                    <v-flex xs4>Unit Type</v-flex>
                    <v-flex xs5>{{ unitFeatures.type_name }}</v-flex>
                    <v-flex xs3>
                        <v-icon class="lead-arrow">arrow_right_alt</v-icon>
                    </v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Rate:</v-flex>
                    <v-flex>${{ formatNumber(unitFeatures.rate) }}/month</v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Promotion Offered:</v-flex>
                    <v-flex>
                        <span v-if="lead.promo_text">{{ lead.promo_text }}</span>
                        <span v-else>No Promotion</span>
                    </v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Features:</v-flex>
                    <v-flex>
                        <div v-for="(feature, i) in unitFeatures.features" :key="i">
                            {{ feature }}
                        </div>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-flex>
        <v-flex>
            <v-layout column class="subheading mx-4 mt-3 mb-1">
                <div class="text-h6">Converted Reservation Details</div>
                <v-layout class="mt-3 mb-2">
                    <v-flex xs4>Size:</v-flex>
                    <v-flex :class="compareSize('width', 'length')">
                        '{{ formatNumber(convertedReservation.width) }} x '{{ formatNumber(convertedReservation.length) }}
                    </v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Unit Type:</v-flex>
                    <v-flex :class="compareString('type_name')">{{ convertedReservation.type_name }}</v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Rate:</v-flex>
                    <v-flex :class="comparePrice('rate')">${{ convertedReservation.rate }}/month</v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Promotion Offered:</v-flex>
                    <v-flex :class="comparePromotion()">
                        <v-flex>
                            <span v-if="convertedReservation.promotion_text">
                                {{ convertedReservation.promotion_text }}
                            </span>
                            <span v-else>No Promotion</span>
                        </v-flex>
                    </v-flex>
                </v-layout>
                <v-layout class="mb-2">
                    <v-flex xs4>Features:</v-flex>
                    <v-flex>
                        <div v-for="(feature, i) in convertedReservation.features" :key="i">
                            <span :class="compareFeature(feature)">{{ feature }}</span>
                        </div>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import { dateMethodMixins } from "@/mixins/dateMethodMixins";
import { mapState } from "vuex";

export default {
  mixins: [dateMethodMixins],

  props: [
    "currentStep",
    "unitFeatures",
    "convertedReservation",
    "lead"
  ],

  methods: {
    toOptions() {
      this.$emit("toOptions");
    },

    toUnitSelect() {
      this.$emit("toUnitSelect");
    },

    formatNumber(val) {
      return (typeof val === "string") ? parseFloat(val) : val;
    },

    compareSize(width, length) {
      const res = this.convertedReservation;
      if (!this.unitFeatures) {
        return "";
      } else if (this.formatNumber(res[width]) !== this.formatNumber(this.unitFeatures[width])) {
        return "success--text";
      } else if (this.formatNumber(res[length]) !== this.formatNumber(this.unitFeatures[length])) {
        return "success--text";
      }
    },

    compareString(item) {
      if (!this.unitFeatures) {
        return "";
      } else if (this.convertedReservation[item] !== this.unitFeatures[item]) {
        return "success--text";
      }
    },

    comparePromotion() {
      if (!this.unitFeatures) {
        return "";
      } else if (this.lead.promo_text !== this.convertedReservation.promotion_text) {
        return "success--text";
      }
    },

    comparePrice(price) {
      const res = this.convertedReservation;
      if (!this.unitFeatures) {
        return "";
      } else if (this.formatNumber(res[price]) !== this.formatNumber(this.unitFeatures[price])) {
        return "success--text";
      }
    },

    compareFeature(feature) {
      if (!this.unitFeatures) {
        return "";
      } else if (this.unitFeatures && !this.unitFeatures.features.includes(feature)) {
        return "success--text";
      }
    }
  },

  computed: {
    ...mapState({
      info: state => state.tenant.info,
      options: state => state.tenant.options
    })
  }
};
</script>

<style>
    .lead-arrow {
        position: absolute;
        font-size: 6rem;
    }
</style>
